
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"11.221","cy":"11.5","r":"11.221","fill":"#FFBA0A"}}),_c('g',{attrs:{"clip-path":"url(#lighting-round_svg__clip0_199_2247)"}},[_c('path',{attrs:{"d":"M16.9 11.454l-6.97 7.47a.498.498 0 01-.853-.436l.913-4.565-3.587-1.347a.497.497 0 01-.187-.809l6.971-7.469a.498.498 0 01.852.436l-.915 4.57 3.587 1.344a.498.498 0 01.187.806h.002z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"lighting-round_svg__clip0_199_2247"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(3.59 3.645)","d":"M0 0h15.934v15.934H0z"}})])])])
          )
        }
      }
    